module.exports = __webpack_public_path__ + "img/add-info.9d764638.svg";